import { render, staticRenderFns } from "./inbox-popup.vue?vue&type=template&id=5d69a42a&"
import script from "./inbox-popup.vue?vue&type=script&lang=js&"
export * from "./inbox-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports